#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment HomeHero on homeHero_MatrixField {
    ... on homeHero_Entry {
        title
        subtitle
        image {
            ... DefaultImageAsset
        }
    }
}
